const hasSupportedPaymentMethods = ({
  supportedPaymentMethods,
  paymentMethods
}) => {
  return supportedPaymentMethods?.some?.(({ name }) =>
    paymentMethods.includes(name)
  );
};

export default hasSupportedPaymentMethods;
